import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = null as null | boolean;

const slice = createSlice({
  name: 'deliveryEstimateFailed',
  initialState,
  reducers: {
    setDeliveryEstimateFailed(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDeliveryEstimateFailed } = slice.actions;

export default slice.reducer;
